import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import moment from 'moment';

import 'react-datepicker/dist/react-datepicker.css';

class Select extends React.PureComponent {
    state = {
        value: null,
        day: 0,
        month: '',
        year: '',
    };

    componentWillMount() {

        if (this.props.value) {
            const mom = moment(this.props.value);
            let dob = mom.format('YYYY-MM-DD');
            this.setState({value: dob, day: mom.format('D'), month: mom.format('MMMM'), year: mom.format('YYYY')});
        }
    }

    update(key, value) {

        const r = {};
        r[key] = value.target.value;

        this.setState(r, () => {

            const {day, month, year} = this.state;
            if (day && month && year) {
                const date = moment(day + '-' + month + '-' + year, 'D-MMMM-YYYY');
                if(date.isValid()) {
                    this.props.onChange(date);
                } else {
                    this.props.onChange(null);

                }
            } else {
                this.props.onChange(null);

            }

        });

    }


    render() {
        let days = [];
        for (let i = 1; i <= 31; i++) {
            days.push(i);
        }

        let months = [
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December'
        ];

        let years = [];
        const minYear = moment().subtract(18, 'years').year();
        for (let i = minYear; i >= 1920; i--) {
            years.push(i);
        }
        return (
            <div className="datepicker-select">
                <div className={this.state.day ? 'niceselect-wrapper' : 'niceselect-wrapper niceselect-default'}>
                    <span className="niceselect-text">{this.state.day || 'Day'}</span>
                    <select
                        name="day"
                        onChange={day => {
                            this.update('day', day);
                        }}
                        value={this.state.day}
                        className="js-nice-select"
                    >
                        <option value="">Day</option>
                        {days.map(day => (
                            <option
                                value={day}
                                key={day}
                            >
                                {day}
                            </option>
                        ))}
                    </select>
                </div>
                <div className={this.state.month ? 'niceselect-wrapper' : 'niceselect-wrapper niceselect-default'}>
                    <span className="niceselect-text">{this.state.month || 'Month'}</span>

                <select
                    name="month"
                    onChange={month => {
                    this.update('month', month);
                }} className="js-nice-select"
                        value={this.state.month}
                >
                    <option value="">Month</option>
                    {months.map(month => (
                        <option
                            value={month}
                            key={month}
                        >
                            {month}
                        </option>
                    ))}
                </select>
                </div>
                <div className={this.state.year ? 'niceselect-wrapper' : 'niceselect-wrapper niceselect-default'}>
                    <span className="niceselect-text">{this.state.year || 'Year'}</span>

                <select
                    name="year"
                    onChange={year => {
                    this.update('year', year);
                }} className="js-nice-select"
                        value={this.state.year}
                >
                    <option value="">Year</option>
                    {years.map(year => (
                        <option
                            value={year}
                            key={year}
                        >
                            {year}
                        </option>
                    ))}
                </select>
                </div>
            </div>
        );
    }
}





Select.propTypes = {
    onChange: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => (
    {}
);

const mapDispatchToProps = (dispatch, ownProps) => (
    {}
);

const SelectLink = connect(
    mapStateToProps,
    mapDispatchToProps,
)(Select);

export default SelectLink;



// WEBPACK FOOTER //
// ./src/Components/Inputs/DatePicker.jsx